class GalleryModal extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.handleOpen = this.handleOpen.bind(this);
  }

  connectedCallback() {
    document.addEventListener('gallery:open', this.handleOpen);
  }

  disconnectedCallback() {
    document.removeEventListener('gallery:open', this.handleOpen);
  }

  handleOpen(event) {
    const { product, startIndex } = event.detail;
    this.product = product;
    this.render(product, startIndex);
  }

  render(product, startIndex) {
    this.innerHTML = `
      <div class="gallery-modal__overlay">
        <div class="gallery-modal__container">
          <button class="gallery-modal__close" aria-label="Close">
            <svg aria-hidden="true" class="pswp__icn" viewBox="0 0 32 32" width="32" height="32">
              <path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"></path>
            </svg>
          </button>
          <div class="keen-slider" id="gallery-keen-slider">
            ${product.media.map(media => this.renderSlide(media)).join('')}
          </div>
          <div class="slider-arrows">
            <button class="slider-arrow slider-arrow--left" id="gallery-prev-btn">
              <svg aria-hidden="true" class="pswp__icn" viewBox="0 0 60 60" width="60" height="60">
                <path d="M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z" id="pswp__icn-arrow"></path>
              </svg>
            </button>
            <button class="slider-arrow slider-arrow--right" id="gallery-next-btn">
              <svg aria-hidden="true" class="pswp__icn" viewBox="0 0 60 60" width="60" height="60">
                <path d="M31 17l3-3 16 16-16 16-3-3 13-13-13-13z"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    `;

    this.style.display = 'block';
    document.body.style.overflow = 'hidden';

    this.addEventListeners();
    this.initSlider(startIndex);
  }

  renderSlide(media) {
    let mediaHtml;
    if (media.media_type === 'image') {
      mediaHtml = `<img src="${media.preview_image.src}" 
                        srcset="${this.generateSrcset(media.preview_image)}"
                        sizes="(min-width: 1200px) 1000px, (min-width: 768px) 80vw, 90vw"
                        loading="lazy" 
                        alt="${media.alt || 'Product image'}" 
                        class="gallery-modal__image">`;
    } else if (media.media_type === 'video') {
      mediaHtml = `<video src="${media.sources[1].url}" controls autoplay loop muted playsinline class="gallery-modal__video"></video>`;
    } else if (media.media_type === 'external_video') {
      if (media.host === 'youtube') {
        mediaHtml = `<iframe src="https://www.youtube.com/embed/${media.external_id}?autoplay=1&mute=1&loop=1&playlist=${media.external_id}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="gallery-modal__iframe"></iframe>`;
      } else if (media.host === 'vimeo') {
        mediaHtml = `<iframe src="https://player.vimeo.com/video/${media.external_id}?autoplay=1&loop=1&autopause=0&muted=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen" class="gallery-modal__iframe"></iframe>`;
      }
    }
    return `<div class="keen-slider__slide">${mediaHtml}</div>`;
  }

  generateSrcset(image) {
    const widths = [300, 500, 800, 1200, 1600, 2000];
    return widths.map(w => `${image.src.replace('.jpg', `_${w}x.jpg`).replace('.png', `_${w}x.png`)} ${w}w`).join(', ');
  }

  addEventListeners() {
    const closeBtn = this.querySelector('.gallery-modal__close');
    const overlay = this.querySelector('.gallery-modal__overlay');
    
    closeBtn.addEventListener('click', this.close.bind(this));
    overlay.addEventListener('click', (event) => {
      if (event.target === event.currentTarget) {
        this.close();
      }
    });
    
    // Add keyboard listener
    this.handleKeydown = this.handleKeydown.bind(this);
    document.addEventListener('keydown', this.handleKeydown);
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
    } else if (event.key === 'ArrowLeft' && this.slider) {
      this.slider.prev();
    } else if (event.key === 'ArrowRight' && this.slider) {
      this.slider.next();
    }
  }
  
  initSlider(startIndex) {
    const sliderEl = this.querySelector('#gallery-keen-slider');
    if (sliderEl && typeof KeenSlider !== 'undefined') {
      this.slider = new KeenSlider(sliderEl, {
        loop: true,
        slides: {
          perView: 1,
          spacing: 0
        },
        initial: startIndex,
        created: (instance) => {
          // Setup arrow navigation
          const prevBtn = this.querySelector('#gallery-prev-btn');
          const nextBtn = this.querySelector('#gallery-next-btn');
          
          if (prevBtn && nextBtn) {
            prevBtn.addEventListener('click', () => instance.prev());
            nextBtn.addEventListener('click', () => instance.next());
          }
        },
        slideChanged: (instance) => {
          // Optional: Add slide change tracking
          const currentSlide = instance.track.details.rel;
          console.log('Current slide:', currentSlide);
        }
      });
    }
  }

  close() {
    // Clean up event listeners
    document.removeEventListener('keydown', this.handleKeydown);
    
    // Destroy slider instance
    if (this.slider) {
      this.slider.destroy();
      this.slider = null;
    }
    
    // Hide modal and restore body scroll
    this.style.display = 'none';
    this.innerHTML = '';
    document.body.style.overflow = '';
  }
}

if (!customElements.get('gallery-modal')) {
  customElements.define('gallery-modal', GalleryModal);
}
